//import * as _ from 'lodash';
const _ = require('lodash');
class AppCache {
  constructor() {
    this.data = {
      order: {},
      redeemData : {},
      updateCC: {},
    };
  }

  setOrderInfo(orderInfo) {
    this.data.order = _.clone(orderInfo);
  }

  getOrderInfo() {
    return this.data.order;
  }

  setRedeemData(redeemData){
    this.data.redeemData = _.clone(redeemData);
  }

  getRedeemData(){
    return this.data.redeemData;
  }

  setUpdateCC(userId){
    this.data.updateCC= _.clone(userId);
  }

  getUpdateCC(){
    return this.data.updateCC;
  }

}

//module.exports= AppCache
//export default AppCache;
export default new AppCache();
